import React from 'react';
import { Waypoint } from 'react-waypoint';
import { trackEvent } from '@99designs/tracking';

export interface Props {
    children: React.ReactNode;
    pageName: string;
    pageElement: string;
}

function TrackScrollToPageElement({ children, pageName, pageElement }: Props) {
    let scrollableAncestor: (Window & typeof globalThis) | null = null;
    if (typeof window !== 'undefined') {
        scrollableAncestor = window;
    }
    return (
        <Waypoint
            fireOnRapidScroll={false}
            scrollableAncestor={scrollableAncestor}
            onEnter={() =>
                trackEvent('Page Scrolled', {
                    page_name: pageName,
                    to_element: pageElement,
                })
            }
        >
            {children}
        </Waypoint>
    );
}

export default TrackScrollToPageElement;
